import { UserSettingsSignInAvatar, useUserProfile } from '@backstage/plugin-user-settings';
import { SidebarUserProfile } from '@ipen/components';
import { Link, useLocation } from 'react-router-dom';

type Props = {
  className?: string;
};

export const BackstageUserProfile = ({
  className,
}: Props) => {
  const { profile } = useUserProfile();
  const location = useLocation();

  const name = profile.displayName ?? profile.email ?? 'Settings';
  const isActive = location.pathname.startsWith('/settings');

  return (
    <SidebarUserProfile
      active={isActive}
      avatar={<UserSettingsSignInAvatar size={30} />}
      className={className}
      component={Link}
      name={name}
      to="/settings"
    />
  );
};
